import React, { useState } from 'react';
import '../WidgetEditTypes/TopWidgetEdit.css';
import ColorSettingsSection from './ColorSettingsSection';
import FontSettingsSection from './FontSettingsSection';
import LayoutSettingsSection from './LayoutSettingsSection';

function MoreSettingsSection({ colors, colorConfig = [], fontConfig = [], layoutConfig = [], editData, handleInputChange }) {
    
    return (
        <div>
            {/* More Settings Header - Nur Überschrift */}
            <div className="widget-trenner">  
                <h3>More Settings</h3>
                <hr className="hrrrr" />
            </div>

            {/* Color Settings mit eigenem Toggle */}
            {colorConfig && colorConfig.length > 0 && (
                <div style={{ marginTop: '15px' }}>
                    <ColorSettingsSection 
                        colors={colors}
                        colorConfig={colorConfig}
                        editData={editData}
                        handleInputChange={handleInputChange}
                    />
                </div>
            )}

            {/* Font Settings mit eigenem Toggle */}
            {fontConfig && fontConfig.length > 0 && (
                <FontSettingsSection 
                    fontConfig={fontConfig}
                    editData={editData}
                    handleInputChange={handleInputChange}
                />
            )}

            {/* Layout Settings mit eigenem Toggle */}
            {layoutConfig && layoutConfig.length > 0 && (
                <LayoutSettingsSection 
                    layoutConfig={layoutConfig}
                    editData={editData}
                    handleInputChange={handleInputChange}
                />
            )}
        </div>
    );
}

export default MoreSettingsSection;
